import { render, staticRenderFns } from "./invoice_form.vue?vue&type=template&id=afaebc88&scoped=true"
import script from "./invoice_form.vue?vue&type=script&lang=js"
export * from "./invoice_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaebc88",
  null
  
)

export default component.exports